export class HealthInsurance {
  private _healthInsuranceCode: number
  private _healthInsuranceName: string
  private _healthPlanCode: number
  private _healthPlanName: string
  private _healthCard?: string
  private _ansRegister?: string
  private _categoryId?: string
  private _categoryName?: string

  constructor(
    healthInsuranceCode: number,
    healthInsuranceName: string,
    healthPlanCode: number,
    healthPlanName: string,
    healthCard?: string,
    ansRegister?: string,
    categoryId?: string,
    categoryName?: string
  ) {
    this._healthInsuranceCode = healthInsuranceCode
    this._healthInsuranceName = healthInsuranceName
    this._healthPlanCode = healthPlanCode
    this._healthPlanName = healthPlanName
    this._healthCard = healthCard
    this._ansRegister = ansRegister
    this._categoryId = categoryId
    this._categoryName = categoryName
  }

  get healthInsuranceCode(): number {
    return this._healthInsuranceCode
  }

  set healthInsuranceCode(value: number) {
    this._healthInsuranceCode = value
  }

  get healthInsuranceName(): string {
    return this._healthInsuranceName
  }

  set healthInsuranceName(value: string) {
    this._healthInsuranceName = value
  }

  get healthPlanCode(): number {
    return this._healthPlanCode
  }

  set healthPlanCode(value: number) {
    this._healthPlanCode = value
  }

  get healthPlanName(): string {
    return this._healthPlanName
  }

  set healthPlanName(value: string) {
    this._healthPlanName = value
  }

  get healthCard(): string {
    return <string>this._healthCard
  }

  set healthCard(value: string) {
    this._healthCard = value
  }

  get ansRegister(): string {
    return <string>this._ansRegister
  }

  set ansRegister(value: string) {
    this._ansRegister = value
  }

  get categoryId(): string {
    return this._categoryId
  }

  set categoryId(value: string) {
    this._categoryId = value
  }
  get categoryName(): string {
    return this._categoryName
  }

  set categoryName(value: string) {
    this._categoryName = value
  }
}
